// Package Imports
import { z } from 'zod'

const authValidationErrors = {
  email: {
    required: 'E-Posta alanının doldurulması zorunludur!',
    invalid: 'Geçersiz e-posta adresi girdiniz!',
    max: 'E-Posta adresi en fazla 50 karakter uzunluğunda olmalıdır!',
  },
  password: {
    required: 'Şifre alanının doldurulması zorunludur!',
    min: 'Şifre alanı en az 8 karakter uzunluğunda olmalıdır!',
    max: 'Şifre alanı en fazla 25 karakter uzunluğunda olmalıdır!',
    containsSpace: 'Şifre boşluk karakteri içeremez!',
    lowercase: 'Şifre en az 1 küçük harf içermelidir!',
    uppercase: 'Şifre en az 1 büyük harf içermelidir!',
    digit: 'Şifre en az 1 rakam içermelidir!',
    specialChar: 'Şifre en az 1 özel karakter içermelidir!',
    match: 'Şifreler eşleşmiyor!',
  },
} as const

const { email, password } = authValidationErrors

export const signOutStatusSchema = z.object({
  status: z.enum(['signedOut', 'requested']).optional(),
  redirectTo: z.string().optional(),
})

export const signInSchema = z.object({
  email: z.email({
    error: email.invalid,
  }),
  password: z.string().min(1, password.required),
})
export const forgotPasswordSchema = z.object({
  email: z.email({
    error: email.invalid,
  }),
})

export const resetPasswordSchema = z
  .object({
    new_password: z
      .string()
      .min(1, password.required)
      .min(8, password.min ?? 'Şifre en az 8 karakter olmalıdır.')
      .max(25, password.max ?? 'Şifre en fazla 25 karakter olmalıdır.')
      .refine((val) => !/\s/.test(val), { message: password.containsSpace })
      .refine((val) => /[a-z]/.test(val), { message: password.lowercase })
      .refine((val) => /[A-Z]/.test(val), { message: password.uppercase })
      .refine((val) => /\d/.test(val), { message: password.digit })
      .refine((val) => /[!@#$%^&*()_\-+={}[\]|:;"'<>,.?/~`]/.test(val), {
        message: password.specialChar,
      }),
    confirm_password: z
      .string()
      .min(1, password.required)
      .min(8, password.min ?? 'Şifre en az 8 karakter olmalıdır.')
      .max(25, password.max ?? 'Şifre en fazla 25 karakter olmalıdır.'),
  })
  .refine((v) => v.new_password === v.confirm_password, {
    message: password.match,
    path: ['confirm_password'],
  })
